import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionBillingAddress } from "../../../api/transaction-type";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  salesOrderPaymentTable,
  salesOrderScheduleTable,
} from "../../../config/grid-column-defs";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, Grid, Tabs, Tab, CircularProgress } from "@mui/material";
import TabPanel from "../../../components/TabPanel";

export default function CashSaleBilling() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    if (user.token) {
      getTransactionBillingAddressData();
    }
  }, [user.token]);

  async function getTransactionBillingAddressData() {
    setLoading(true);
    try {
      const { data } = await getTransactionBillingAddress(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
    // setRowData([])
  }

 return loading ? (
       <>
           <Box className="viewDetilsBox">
             <Grid container className="mb-2">
               <Grid item xs={12}>
                 <div
                   style={{
                     width: "100%",
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                   }}
                 >
                   <CircularProgress></CircularProgress>
                 </div>
               </Grid>
             </Grid>
           </Box>
       </>
     ) : (
    <>
    {
      rowData?.map((el,index)=>(
        <Box className="viewDetilsBox" key={index} >
              <Grid container className="mb-2" spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container>
                   
                    <Grid item xs={12} sm={12} md={12}>
                      <Grid container>
                        <Grid item xs={12} sm={12} md={12} className="m-b-10">
                          <p className="titleHeading">Billing Address</p>
                          <p className="tFormlabel">BILL TO</p>
                          <p className="tFormName">{el.vendor}  <span style={{ color: "#0066b2" }}>Map</span></p>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                      <Grid container>
                        <Grid item xs={12} sm={12} md={12} className="m-b-10">
                          <p className="titleHeading">Payment</p>
                          <p className="tFormlabel">PAYMENT METHOD</p>
                          <p className="tFormName">{el?.payment_method}</p>
                        </Grid>
                       
                      </Grid>
                    </Grid>
                        {/* <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormlabel">
                            CONTRACT NOTES PER CONTRACT RECORD
                          </p>
                          <p className="tFormName">{el.contract_notes_per_contract_record}</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormlabel">
                            UPLIFT PER PAPER CONTRACT-SO-NEW
                          </p>
                          <p className="tFormName">{el.uplift_per_paper_contract_so_new}</p>
                        </Grid> */}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">TIMESTAMP</p>
                  <p className="tFormName">{el.timestamp}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">
                    BILLING INSTRUCTION PER CLIENT RECORD
                  </p>
                  <p className="tFormName">{el.billing_instruction_per_client_record}</p>
             </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">GST/VAT REG ID</p>
                  <p className="tFormName">{el.gst_vat_reg_id}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">TIMESTAMP SS</p>
                  <p className="tFormName">{el.timestamp_ss}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">UPLIFT TYPE (FROM CONTRACT)</p>
                  <p className="tFormName">{el.uplift_type}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">TAX PREFIX</p>
                  <p className="tFormName">{el.tax_prefix}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">DELIVERY COMMENT</p>
                  <p className="tFormName">{el.delivery_comment}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">
                    UPLIFT FOR SYSTEM CALCS (FROM CONTRACT)
                  </p>
                  <p className="tFormName">{el.uplift_for_system_calcs}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">TAX SUFFIX</p>
                  <p className="tFormName">{el.tax_suffix}</p>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">
                    INVOICE DELIVERY METHOD PER CLIENT RECORD
                  </p>
                  <p className="tFormName">{el.invoice_delivery_method_per_client_record}</p>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">
                    UPLIFT PER PAPER CONTRACT (FROM CONTRACT)-NEW
                  </p>
                  <p className="tFormName">{el.uplift_per_paper_contract}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="tFormlabel">GST/VAT SHIP TO COUNTRY</p>
                  <p className="tFormName">{el.gst_vat_ship_to_country}</p>
                </Grid> */}
              </Grid>
            </Box> 
      ))
    }
 
    </>
  );
}
